














import { Vue, Component, Prop } from 'vue-property-decorator';
import type { IField } from '@lib-shared/fields/types/field';

@Component
export default class SignatureField extends Vue {
  @Prop() field!: IField;
  @Prop() disabled: boolean;
  @Prop() fullName: string;

  get placeholder(): string {
    return this.field.label || this.defaultPlaceholder;
  }

  get defaultPlaceholder(): string {
    return this.disabled
      ? this.$t('waiting-for-signature').toString()
      : this.$t('write-your-signature-here').toString();
  }

  get hasSignature(): boolean {
    return !!this.field && !!this.field.signatureBiometric;
  }

  get biometricSignature(): string {
    return this.field.signatureBiometric;
  }

  handleClick() {
    if (!this.hasSignature && !this.disabled) {
      this.$emit('click');
    }
  }
}
